import { createContext, useContext } from "react";
export const QuiTabsContext = createContext({});
export const useQuiTabs = () => {
    const context = useContext(QuiTabsContext);
    if (!context) {
        throw new Error("useQuiTabs must be used within a QuiTabsContext provider");
    }
    // need to cast to unknown first since TTabs is more specific than string
    return context;
};
